import React, { ComponentType, FC, ReactNode } from 'react';

import findChildByType from '../../../utils/components/#findChildByType';
import excludeChildrenByType from '../../../utils/components/#excludeChildrenByType';

import Modal from '../Modal';
import { StyledIcon, StyledIconWrapper, StyledContentWrapper, StyledT2 } from './Dialog.styles';

export interface DialogContentWrapperProps {
  Icon: ComponentType<any>;
  modalTitle: ReactNode;
  color: string;
  children: ReactNode;
}

const DialogContentWrapper: FC<DialogContentWrapperProps> = ({
  color,
  Icon,
  children,
  modalTitle,
}) => {
  const content = excludeChildrenByType(children, Modal.Footer);
  const footer = findChildByType(children, Modal.Footer);

  return (
    <>
      {Icon && (
        <StyledIconWrapper>
          <StyledIcon as={Icon} color={color} />
        </StyledIconWrapper>
      )}
      {modalTitle && <StyledT2 align="center">{modalTitle}</StyledT2>}
      <StyledContentWrapper data-testid="DialogContentWrapper">
        {content}
      </StyledContentWrapper>
      {footer}
    </>
  );
};

export default DialogContentWrapper;
